import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useFetchMoreDancers = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const { t } = useTranslation();

  const fetchMoreDancers = async (fetchMore, variables) => {
    setIsLoading(true);
    setError(null);
    try {
      await fetchMore({
        variables,
        updateQuery: (previousData, { fetchMoreResult }) => {
          if (!fetchMoreResult) return previousData;

          const { group: { dancers_paginated: { nodes: dancers, ...dancersPaginated }, ...groupDetails }, ...otherData } = previousData;
          const { group: { dancers_paginated: { nodes: newDancers, pageInfo, totalCount } } } = fetchMoreResult;

          return {
            group: {
              ...groupDetails,
              dancers_paginated: {
                ...dancersPaginated,
                nodes: [...dancers, ...newDancers],
                pageInfo: pageInfo,
                totalCount: totalCount
              }
            },
            ...otherData
          };
        },
      });
    } catch (error) {
      setError(t('errors.generic'));
    }
    setIsLoading(false);
  };
  return {
    isLoading,
    fetchMore: fetchMoreDancers,
    error,
  };
};
